// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TerminatedAgentIconOverlay = require("../../common/Agent/TerminatedAgentIconOverlay.bs.js");
let BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql = require("../../../__generated__/BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.bs.js");

let convertFragment = BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

let Fragment_membershipStatusV5_decode = BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.Utils.membershipStatusV5_decode;

let Fragment_membershipStatusV5_fromString = BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.Utils.membershipStatusV5_fromString;

let Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerPageMatchAnonymousAgent(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "xSmall";
  let match = RescriptRelay_Fragment.useFragment(BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, props.agent);
  let tmp = match.membershipStatus;
  if (tmp === "TERMINATED") {
    return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
      size: size,
      children: JsxRuntime.jsx(AgentInfo__Jsx3.make, {
        avatar: AvatarSrcUrl.place_holder,
        size: size,
        name: "The agent chose to hide their name",
        brokerage: "NO LONGER ON TAN",
        wrapName: name => JsxRuntime.jsx("div", {
          children: name,
          className: "font-medium"
        })
      })
    });
  }
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
    avatar: AvatarSrcUrl.place_holder,
    size: size,
    name: "The agent chose to hide their name",
    wrapName: name => JsxRuntime.jsx("div", {
      children: name,
      className: "font-medium"
    })
  });
}

let make = BuyerPageMatchAnonymousAgent;

exports.Fragment = Fragment;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
